import { Action } from '@/authorization/action';
import { Subject } from '@/authorization/subject';
import { useAppAbility } from '@/authorization/use-app-ability';
import type { ProductionDeclaration } from '@/types/core/purchase-order/production-declaration';
import { ProductionDeclarationStatusCode } from '@/types/core/purchase-order/production-declaration-status-code';

export function useCanManageSubmittedProductionDeclaration(
  declaration: Pick<ProductionDeclaration, 'status'>,
): boolean {
  const ability = useAppAbility();

  return (
    declaration.status.code === ProductionDeclarationStatusCode.Submitted &&
    ability.can(Action.Manage, Subject.ProductionDeclaration)
  );
}
